import type { AudioPlay } from 'kaplay'
import type { KAPLAYCtx } from './types.ts'

type UseMusicOptions = {
  volume?: number
}

let time: number = 0
let volume: number = 0.05
let music: AudioPlay
let isLoaded = false

export function useMusic(k: KAPLAYCtx, opt?: UseMusicOptions) {
  if (opt?.volume) volume = opt?.volume

  if (!isLoaded) {
    k.loadMusic('music', 'music/music.ogg')
    isLoaded = true
  }

  if (!music) music = k.play('music', { volume, paused: true, loop: true })

  function replayMusic() {
    time = 0
    music.play(time)
  }

  function playMusic() {
    music.play(time)
  }

  function pauseMusic() {
    time = music.time()
    music.stop()
  }

  function stopMusic() {
    music.stop()
  }

  function toggleMusic() {
    if (music.paused) playMusic()
    else pauseMusic()
  }

  function setMusicVolume(val: number) {
    if (val >= 0 && val <= 1) {
      volume = val
      music.volume = volume
    }
  }

  function isPaused() {
    return music.paused
  }

  return {
    playMusic,
    replayMusic,
    stopMusic,
    pauseMusic,
    toggleMusic,
    setMusicVolume,
    isPaused,
  }
}
